var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.735,
    height: 161.207,
    viewBox: "0 0 141.735 161.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .loaderA {\n        opacity: 0.695;\n      }\n\n      .loaderB {\n        fill: #b1e7fe;\n      }\n\n      .loaderC {\n        fill: #b1e7ff;\n      }\n\n      .loaderD {\n        fill: #6ac7f0;\n      }\n\n      .loaderE {\n        fill: #54b7e3;\n      }\n\n      .loaderF {\n        fill: #2196c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "loaderA",
    transform: "translate(-672 -420)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "loaderB",
    d: "M337.919,434.805l17.191,9.96v-76.8l-17.191,9.861Z",
    transform: "translate(458.625 94.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loaderC",
    d: "M297.443,401.059,280.2,410.952l66.88,38.613v-19.85Z",
    transform: "translate(393.665 131.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loaderD",
    d: "M296.511,377.734l-17.191-9.96v76.8l17.191-9.861Z",
    transform: "translate(392.679 94.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loaderE",
    d: "M346.853,367.883v-19.85L280.4,386.4l17.161,9.942Z",
    transform: "translate(393.889 71.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loaderF",
    d: "M363.221,396.494l17.246-9.893-66.8-38.569v19.85Z",
    transform: "translate(431.329 71.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "loaderC",
    d: "M313.664,429.635v19.85L380.2,411.072l-17.161-9.942Z",
    transform: "translate(431.329 131.721)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.01a1b4c8.svg";
export { ForwardRef as ReactComponent };